module.exports = __webpack_public_path__ + "static/media/hudsonvalley.5a38d0b6.svg";